export default __webpack_public_path__ + "static/media/dep2_0.fcef1349.png";